import { Input } from '@alfa-bank/site-input';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Autocomplete } from './components/autocomplete/autocomplete';
import { ArrowIcon } from './components/arrow-icon/arrow-icon';
import { SelectActions } from './classes';
import { BaseSelect as Component } from './select';
import styles from './styles/styles.css';
import type { IDeps, TSelect } from './models';

export const BaseSelect = createWidget<IDeps, TSelect>({
    styles,
    Input,
    Autocomplete,
    ArrowIcon,
    SelectActions,
})(Component);
